import { FormField, TextInput } from 'grommet';

export const CompanyName = (): JSX.Element => {
  return (
    <FormField
      name="companyName"
      htmlFor="company-name"
      label="Company name"
      required
    >
      <TextInput
        id="company-name"
        name="companyName"
        placeholder="Company name"
      />
    </FormField>
  );
};
